module.exports = __webpack_public_path__ + "static/media/chart_blue.455c9f52.svg";